import styled, { css } from 'styled-components';

const getBackground = ({ overlapping, theme }) => {
  if (!overlapping) return css``;

  return css`
    ${overlapping &&
      css`
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
      `}
    z-index: 5;
    &::after {
      content: '';
      background-size: contain;
      background-position: center;
      background-color: ${theme.colors.light_darker};
      opacity: 0.5;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      position: absolute;
      z-index: -1;
    }
  `;
};
const StyledAudiencesOpeners = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  margin: 0 auto;
  padding: 0 4rem;
  background-color: transparent;
  ${props => getBackground(props)}
`;

const StyledAudiencesOpenersWrapper = styled.div`
  flex: 5;
  width: 100%;
  flex-direction: row;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledAudiencesOpenersRow = styled.div`
  display: flex;
  flex-flow: row;
  flex: 1;
  justify-content: center;
  flex-wrap: wrap;
  width: 100%;
`;

const StyledColumn = styled.div`
  flex-basis: 33.3%;
`;

export {
  StyledAudiencesOpeners,
  StyledAudiencesOpenersRow,
  StyledAudiencesOpenersWrapper,
  StyledColumn,
};
